import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { DialogContent, DialogContentText } from "@material-ui/core";
import { ConflictType } from "../types/conflictNoticeTypes";
import alertTriangle from '../../../assets/svgs/alert-triangle.svg';
import { formatToMinutesHours } from "./conflictNoticeHelper";

interface ConflictNoticeProps {
    isDialogOpen: boolean,
    onCancel: any,
    conflictType: ConflictType,
    plannerBreakDuration?: number | null,
    plannerBreakStartTime?: number | null,
    plannerMaxBreakDelay?: number | null,
}

const useStyles = makeStyles({
    dialog: {
        width: 400,
        background: 'white',
        borderRadius: 0
    },
    content: {
        color: '#00152E',
        fontSize: 16,
        fontWeight: 700,
        fontFamily: 'lato',
        lineHeight: 'normal',
        textAlign: 'center'
    },
    icon: {
        'filter': 'invert(36%) sepia(96%) saturate(1083%) hue-rotate(331deg) brightness(101%) contrast(89%)'
    },
    iconContainer: {
        textAlign: 'center',
        margin: '20px 0px'
    },
    onlyOneButtonStyle: {
        width: '100%'
    }
});

const getDialogText = (conflictType: ConflictType,
    plannerBreakDuration?: number | null,
    plannerBreakStartTime?: number | null,
    plannerMaxBreakDelay?: number | null): string => {
    let lastPart = '';
    if (conflictType === ConflictType.lunchBreak && plannerBreakDuration && plannerBreakStartTime && plannerMaxBreakDelay) {
        const plannerBreakEndTime = plannerBreakStartTime + plannerMaxBreakDelay * 60;
        lastPart = `Please leave a gap of at least ${plannerBreakDuration} minutes between ${formatToMinutesHours(plannerBreakStartTime)} and ${formatToMinutesHours(plannerBreakEndTime)}.`;
    }
    
    switch (conflictType) {
        case ConflictType.overlap:
            return 'The time you have selected for this trip overlaps another trip. Please choose a new time for this trip.'
        case ConflictType.lunchBreak:
            return `This trip does not leave enough time for a meal break. ${lastPart}`
        case ConflictType.shiftEnd:
            return 'This trip is not estimated to complete before shift end. Please choose an earlier start time for this trip.'
        case ConflictType.wrongAcuity:
            return 'Transfer acuity is too high to be placed here.'
        case ConflictType.Allow:
            return 'Access denied: Your current user privileges do not allow this action.'
        case ConflictType.Reschedule:
            return 'You currently do not have access to reschedule trips here.'
        case ConflictType.LocationNotAllowed:
            return 'Access denied: Your current user location privileges do not allow this action.'
       
    }
}

const ConflictNotice: React.FC<ConflictNoticeProps> = ({
    isDialogOpen,
    onCancel,
    conflictType,
    plannerBreakDuration,
    plannerBreakStartTime,
    plannerMaxBreakDelay
}) => {
    const classes = useStyles();
    const dialogText = getDialogText(
        conflictType,
        plannerBreakDuration,
        plannerBreakStartTime,
        plannerMaxBreakDelay
    );
    return (
        <Dialog open={isDialogOpen}
            onClose={onCancel}
            PaperProps={{ className: classes.dialog }}>
            <DialogContent>
                <div className={classes.iconContainer} >
                    <img
                        src={alertTriangle}
                        width="30"
                        height="30"
                        className={classes.icon} />
                </div>
                <DialogContentText>
                    <div className={classes.content}>{dialogText}</div>

                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary"
                    className={classes.onlyOneButtonStyle}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default ConflictNotice;